// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1T6pv","upload":"Small_upload__2EUq-","imageWrap":"Small_imageWrap__3UdS-","removeBtn":"Small_removeBtn__3fcyb"};